import _createClass from "@babel/runtime/helpers/esm/createClass";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes, { shape, string, object, oneOfType } from 'prop-types';
import RCE5Renderer from './rce5Renderer';
import { RceConfigContext, RceConfigKeys } from '@instructure/quiz-common';
export var RCE5RendererParameterAdapter = /*#__PURE__*/function (_Component) {
  function RCE5RendererParameterAdapter() {
    var _this;
    _classCallCheck(this, RCE5RendererParameterAdapter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, RCE5RendererParameterAdapter, [].concat(args));
    _defineProperty(_this, "getEnhancement", function () {
      var _this$context;
      return _this.props.enhancementProps || ((_this$context = _this.context) === null || _this$context === void 0 ? void 0 : _this$context.rendererEnhancement);
    });
    _defineProperty(_this, "getCanvasToolId", function () {
      var _this$context2;
      return _this.props.canvasToolId || ((_this$context2 = _this.context) === null || _this$context2 === void 0 || (_this$context2 = _this$context2.ltiApps) === null || _this$context2 === void 0 ? void 0 : _this$context2.canvasToolId);
    });
    _defineProperty(_this, "getCanvasConfig", function () {
      var _this$context3;
      return _this.props.canvasConfig || ((_this$context3 = _this.context) === null || _this$context3 === void 0 || (_this$context3 = _this$context3.rcs) === null || _this$context3 === void 0 ? void 0 : _this$context3.canvasConfig);
    });
    _defineProperty(_this, "getFeatureFlags", function () {
      var _this$context4;
      return _this.props.featureFlags || ((_this$context4 = _this.context) === null || _this$context4 === void 0 ? void 0 : _this$context4.featureFlags);
    });
    _defineProperty(_this, "composeMandatoryProps", function () {
      return {
        content: _this.props.content,
        customStyles: _this.props.customStyles
      };
    });
    _defineProperty(_this, "render", function () {
      var _this$context5;
      return /*#__PURE__*/React.createElement(RCE5Renderer, Object.assign({}, _this.composeMandatoryProps(), {
        enhancementProps: _this.getEnhancement(),
        canvasToolId: _this.getCanvasToolId(),
        canvasConfig: _this.getCanvasConfig(),
        featureFlags: _this.getFeatureFlags(),
        defaultRceSettings: (_this$context5 = _this.context) === null || _this$context5 === void 0 ? void 0 : _this$context5.defaultRceSettings,
        ariaHidden: _this.props.ariaHidden
      }));
    });
    return _this;
  }
  _inherits(RCE5RendererParameterAdapter, _Component);
  return _createClass(RCE5RendererParameterAdapter);
}(Component);
_defineProperty(RCE5RendererParameterAdapter, "contextType", RceConfigContext);
_defineProperty(RCE5RendererParameterAdapter, "propTypes", {
  content: oneOfType([string, object]),
  customStyles: PropTypes.object,
  enhancementProps: shape(_defineProperty({}, RceConfigKeys.canvasOrigin, string)),
  canvasToolId: string,
  canvasConfig: object,
  ariaHidden: PropTypes.bool,
  featureFlags: object
});
_defineProperty(RCE5RendererParameterAdapter, "defaultProps", {
  customStyles: {},
  content: '',
  enhancementProps: null,
  canvasToolId: null,
  canvasConfig: null,
  ariaHidden: false,
  featureFlags: null
});
export default RCE5RendererParameterAdapter;